<template>
  <div id="app">
    <transition
      name="fade"
      mode="out-in"
    >
      <MainView />
    </transition>
  </div>
</template>

<script>

import MainView from './views/MainView.vue';

export default {
  name: 'App',
  components: {
    MainView,
  },
};
</script>

